import { campaignContext, gaCampaign, clearAttribution, internalTraffic, sendFunnelEvent } from './campaignAttribution';
import { stripQuery } from './observability';
export const analyticsId = (hostname = window.location.hostname) => ['sonikly.ai', 'www.sonikly.ai'].includes(hostname) ? 'G-FZ32MPYF6L' : process.env.REACT_APP_GA4_MEASUREMENT_ID;
export const CONSENT_KEY = 'sonikly.analytics.v1';
export function analyticsChoice() {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
}
let automatic = false;
let policyPromise;
export const privacySignal = () => navigator.globalPrivacyControl === true || navigator.doNotTrack === '1';
export const analyticsAllowed = () => !privacySignal() && !internalTraffic() && window.location.pathname !== '/reset-password' &&
  (analyticsChoice() === 'accepted' || (!analyticsChoice() && automatic));
export function resolveAnalyticsPolicy() {
  if (!policyPromise) policyPromise = (async () => {
    if (privacySignal()) clearAttribution();
    if (analyticsChoice() || privacySignal() || window.location.pathname === '/reset-password') {
      startAnalytics();
      return { prompt: false };
    }
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000);
    try {
      const response = await fetch('/api/analytics-policy', { signal: controller.signal, cache: 'no-store' });
      const policy = response.ok ? await response.json() : {};
      automatic = policy.automatic === true;
    } catch { automatic = false; }
    finally { clearTimeout(timeout); }
    startAnalytics();
    return { prompt: !automatic && !analyticsChoice() && !privacySignal() };
  })();
  return policyPromise;
}
let started = false;
export function startAnalytics() {
  const id = analyticsId();
  if (!analyticsAllowed() || started) return false;
  started = true;
  window.dispatchEvent(new Event('sonikly-analytics-ready'));
  if (!id) { sendFunnelEvent('page_view', { page: window.location.pathname }); return true; }
  window[`ga-disable-${id}`] = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
  window.gtag('consent', 'update', { analytics_storage: 'granted' });
  window.gtag('js', new Date());
  window.gtag('config', id, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false, page_location: stripQuery(window.location.href), page_referrer: stripQuery(document.referrer), ...gaCampaign(campaignContext()) });
  const script = document.createElement('script');
  script.async = true;
  script.dataset.soniklyGa = 'true';
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(script);
  window.gtag('event', 'page_view', { page_location: stripQuery(window.location.href), page_path: window.location.pathname, page_title: document.title });
  sendFunnelEvent('page_view', { page: window.location.pathname });
  return true;
}
export function chooseAnalytics(choice) {
  try { localStorage.setItem(CONSENT_KEY, choice); } catch { return; }
  if (choice === 'accepted') startAnalytics();
  else {
    clearAttribution();
    const id = analyticsId();
    window[`ga-disable-${id}`] = true;
    if (window.gtag) window.gtag('consent', 'update', { analytics_storage: 'denied' });
    document.querySelectorAll('script[data-sonikly-ga]').forEach((s) => s.remove());
    document.cookie.split(';').forEach((entry) => {
      const name = entry.trim().split('=')[0];
      if (!/^_ga(?:_|$)/.test(name)) return;
      const parts = window.location.hostname.split('.');
      document.cookie = `${name}=; Max-Age=0; path=/`;
      for (let i = 0; i < parts.length - 1; i += 1) document.cookie = `${name}=; Max-Age=0; path=/; domain=.${parts.slice(i).join('.')}`;
    });
    started = false;
  }
  window.dispatchEvent(new Event('sonikly-analytics-choice'));
}
